import moment from 'moment'
import { safePost, publishingHostUrl } from './http'
import { IStringObject, trace } from './common'
import { CACHE_PREFIX, VALIDATION_PATTERNS } from '../config'

export interface IMetric {
  name: string
  value: string
  tags?: IStringObject[]
}

export const metricsUrl = `${publishingHostUrl}/metrics`

export const createGroupUserActivityMetric = (
  groupName: string
): Promise<void> =>
  createMetric({
    name: 'group_user_activity',
    value: '1',
    tags: [
      {
        group: groupName,
      },
    ],
  })

export const createMetric = (metricData: IMetric): Promise<void> =>
  createMetrics([metricData])

export const createMetrics = (metricsData: IMetric[]): Promise<void> =>
  safePost(metricsUrl, metricsData)

export const sendLoggingMetric = (path: string): void => {
  const matchGroupPage = path.match(VALIDATION_PATTERNS.GROUP_PATH)
  const matchGraphicPage = path.match(VALIDATION_PATTERNS.GRAPHIC_PATH)
  const matchSearchPage = path.match(VALIDATION_PATTERNS.CONSUMER_SEARCH_PATH)

  const shouldTrack = [matchGroupPage, matchGraphicPage, matchSearchPage].some(
    (match) => !!match && match.index !== -1
  )

  if (!shouldTrack) {
    return
  }

  const loggingKey = `${CACHE_PREFIX}logging_metrics`
  const lastDayVisited = localStorage.getItem(loggingKey)
  const momentNow = moment.utc()

  if (lastDayVisited) {
    const lastDayVisitedMoment = moment.utc(lastDayVisited)
    const isSameDay = lastDayVisitedMoment.isSame(momentNow, 'day')
    if (isSameDay) {
      return
    }
  }

  try {
    createMetric({ name: 'portal_user_activity', value: '1' })
    localStorage.setItem(loggingKey, momentNow.format())
  } catch (error) {
    trace(error)
  }
}
